import textStrings from "@/consts/text-strings"

export const DEFAULT_QUEUE_FILTER = { name: textStrings.QUEUE_ALL, id: null }

export const HELP_CENTER_LINK = "https://intercom.help/nextme-app/en"
export const TOC_LINK = "https://nextmeapp.com/terms-of-use/"

export const INDUSTRIES_USING_OLD_WAITTIME_FIELD = ["Restaurants"]
